import { isEmpty } from 'lodash';

function isNotEmpty(value?: any): boolean {
  return !isEmpty(value);
}

export { isNotEmpty };
